import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-hk'
import 'moment/locale/th'
import { langs, lang } from './Config'

Vue.prototype.$moment = moment

function changeLang(lang) {
  const selected = langs.filter(i => i.localKey === lang)[0]
  
  if (selected) {
    moment.locale(selected.momentKey)
  } else {
    moment.locale('zh-cn')
  }
}

changeLang(lang)